module.exports = __webpack_public_path__ + "img/how-to-play-impostor.4b73184f.png";